import { Input } from 'antd'
import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import DescriptionFormItem from 'components/CIMSFormItem/common/DescriptionFormItem'

export const CreateNonUserEmailModalBody: React.FC = () => {
  return (
    <>
      <CIMSFormItem
        name={'label'}
        label={'Label'}
        help={HelpMessage.Administration.NonUserEmails.Label}
      >
        <Input />
      </CIMSFormItem>
      <DescriptionFormItem entityName="Non User Email" />
      <CIMSFormItem
        name={'address'}
        label={'Email Address'}
        requiredMessage="Please enter an email address"
        emailMessage="Please enter a valid email address"
        help={HelpMessage.Administration.NonUserEmails.Email}
      >
        <Input />
      </CIMSFormItem>
    </>
  )
}

export interface CreateNonUserEmailModalValues {
  label?: string
  description?: string
  address: string
}
